
















































































import { DateRange } from '@/models';
import { dateRangeMixin } from '@/shared';
import { Actions } from '@/store';
import { resetModel, download, ToastsService } from '@/utils';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import moment from 'moment';

export default mixins(dateRangeMixin).extend({
  name: 'GenerateOpportunityReportModal',
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
    };
  },
  computed: {
    datesUntilStartDate(): DateRange {
      return this.form.startDate
        ? { to: this.form.startDate }
        : { from: null, to: null } as unknown as DateRange;
    },
  },
  methods: {
    resetForm() {
      this.form = resetModel(this.form);
      this.dateRange = null as unknown as DateRange;
    },
    async checkForm() {
      const isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }

      const startDate = moment(this.form.startDate).utc().startOf('day');
      const endDate = moment(this.form.endDate).utc().startOf('day');

      const utcISODateRange = {
        from: startDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        to: endDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
      };

      this.loader.isRequestPending = true;
      try {
        const fileContent = await this.$store.dispatch(Actions.opportunities.fetchReport, utcISODateRange);
        this.loader.isRequestPending = false;
        download(
          `LoG-opportunities_report_${startDate.format('YYYY-MM-DD')}`
          + `_to_${endDate.format('YYYY-MM-DD')}.xlsx`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet/xlsx',
          fileContent,
        );
        ToastsService.success(this.$t('opportunities.generate-report-modal.success-notification') as string);
        this.$bvModal.hide('generate-report-modal');
      } catch (e) {
        throw new Error(e);
      }
    },
  },
});
